import './Legal.css';

export default function Disclaimer() {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <div className="legal-header">
          <span className="legal-tag">Legal</span>
          <h1>Disclaimer</h1>
          <p className="legal-meta">Electradez LLC · Effective Date: March 14, 2025 · Colorado, USA</p>
        </div>

        <div className="legal-body">
          <section>
            <h2>1. Marketplace Only</h2>
            <p>Electradez is an online marketplace platform operated by Electradez LLC. We provide a venue for buyers and sellers to connect. We are not a dealer, broker, or reseller of any vehicles, parts, or accessories listed on the platform.</p>
          </section>

          <section>
            <h2>2. No Endorsement of Listings</h2>
            <p>Electradez does not inspect, verify, endorse, or guarantee the accuracy of any listing posted by users. All listing information — including descriptions, photos, pricing, condition, and specifications — is provided solely by the seller. Buyers are responsible for conducting their own due diligence before making any purchase.</p>
          </section>

          <section>
            <h2>3. No Payment Processing</h2>
            <p>Electradez does not process, hold, or facilitate any payments between buyers and sellers. All financial transactions are conducted directly between users. Electradez assumes no responsibility for payment disputes, fraud, or financial losses arising from transactions between users.</p>
          </section>

          <section>
            <h2>4. Vehicle Compliance</h2>
            <p>Electric motorcycles and similar vehicles may be subject to federal, state, and local laws and regulations including registration, licensing, insurance, and road-use requirements. It is the sole responsibility of the buyer and seller to ensure compliance with all applicable laws in their jurisdiction. Electradez makes no representation regarding the street legality or compliance of any listed vehicle.</p>
          </section>

          <section>
            <h2>5. Safety</h2>
            <p>The use of electric motorcycles and similar vehicles involves inherent risks. Electradez is not responsible for any injuries, accidents, property damage, or other harm arising from the use of any vehicle or part purchased through the platform. Always wear appropriate safety gear and follow all applicable safety guidelines.</p>
          </section>

          <section>
            <h2>6. Accuracy of Information</h2>
            <p>While we strive to maintain a reliable platform, Electradez does not warrant that the platform will be error-free or that any information on the platform is accurate, complete, or current. We reserve the right to correct any errors or omissions at any time.</p>
          </section>

          <section>
            <h2>7. External Links</h2>
            <p>The platform may contain links to third-party websites. Electradez is not responsible for the content, privacy practices, or accuracy of any third-party sites.</p>
          </section>

          <section>
            <h2>8. Contact</h2>
            <p><strong>Electradez LLC</strong><br />
            Colorado, USA<br />
            <a href="mailto:legal@electradez.com">legal@electradez.com</a></p>
          </section>
        </div>
      </div>
    </div>
  );
}
